import styled from "styled-components";
import colors from "../../utils/style/colors.tsx";

export const AccueilSectionWrapper = styled.div`
    background-color: ${colors.white};
    display: flex;
    flex-direction: column;
    margin-bottom: 5%;
`

export const ContentWrapperAccueilSection = styled.div`
    display: flex;
    justify-content: space-between;

    @media (max-width: 768px) {
        flex-direction: column-reverse;
    }
`

export const TextWrapperAccueilSection = styled.div`
    text-align: justify;
    width: 45%;
    height: fit-content;
    margin-top: 2vw;

    @media (max-width: 768px) {
        width: 100%;

        p{
            font-size: 16px;
        }
    }
`